module.exports = __webpack_public_path__ + "3818dda0188c83e0b261e5fa1407a0b0.svg";